import type { FC } from 'react';
import { useContext } from 'react';
import Surface from '@wix/da-ds/pkg/Surface';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DiscountRow from '../../DiscountRow';
import DiscountRowMobileNew from '../DiscountRowMobileNew';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { StudioSection } from '../../../../../types/store';

import s from './DiscountStatusSection.scss';

interface Props {
  title: string;
  discounts: PapiSellerDiscount[];
  statusSection?: StudioSection;
}

const DiscountStatusSection: FC<Props> = ({
  title,
  discounts,
  statusSection,
}) => {
  const isMobile = useContext(MobileContext);

  const RowComponent = isMobile ? DiscountRowMobileNew : DiscountRow;

  return (
    <div className={s['root']}>
      <div className={s['title']}>{title}</div>
      <Surface type={ThemeSurface.SECONDARY} themeOverrideOnly>
        {discounts.map((discount: PapiSellerDiscount) => (
          <RowComponent
            key={discount.discountId}
            discount={discount}
            className={s['discount-row']}
            statusSection={statusSection}
          />
        ))}
      </Surface>
    </div>
  );
};
DiscountStatusSection.displayName = 'DiscountStatusSection';

export default DiscountStatusSection;

